import * as React from 'react'
import { Button, Input, Select, useEffectWithPolling, WidgetWrapper } from 'uxp/components'
import { IUIPropertyDefinitionMap, IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate, registerMobileCardTemplate } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { SelectableItem, selectUIProps } from '../../../common/SelectableItem'
import { ContainerProperty, extractContainerProperties } from '../../../common/ui-props/ContainerProperty'
import { extractTextProperties, TextProperty } from "../../../common/ui-props/TextProperty";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { executeAndBind } from '../../../common/data-source-picker/datasource'
import { bindContainerId, extractContextData, hasValue, loadInitialData, replaceWithData } from '../../../../util'
import './styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IContextData, useInitialContextData } from '../../../../hooks/useContextData'

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {
    let uiProps = props?.uiProps || {};
    let { designer } = props;

    const [currencies, setCurrencies] = React.useState([]);
    const [fromCurrency, setFromCurrency] = React.useState("USD");
    const [toCurrency, setToCurrency] = React.useState("INR");

    const [leftValue, setLeftValue] = React.useState('1');
    const [rightValue, setRightValue] = React.useState('');
    const [clickSide, setClickSide] = React.useState('right');

    const XPRProps: IUIPropertyDefinitionMap = {
        "container": ContainerProperty({
            background: {
                color: "#ffffff",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        'source': DataSourceProperty('Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),

        'title': TextProperty({ text: 'Currency Converter', color: '#000000', size: '18px' }, 'Title'),
        'text': TextProperty({ color: 'lightgrey' }, 'Text'),
        'button': TextProperty({ color: '#13955e' }, 'Button'),
    };

    let { text: title = 'Currency Converter', color: titleColor = '#000000', size: titleFont = '18px' } = uiProps?.title || {};
    let { color: textColor = 'lightgrey' } = uiProps?.text || {};
    let { color: btnColor = '#13955e' } = uiProps?.button || {};

    let { styles: containerStyles } = extractContainerProperties(uiProps.container);

    let [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)
    
    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    
    title = replaceWithData(title, contextData)

    React.useEffect(() => {
        handleConversion();
        getCurrencyValue();
    }, [fromCurrency, toCurrency, currencies, leftValue, rightValue])

    React.useImperativeHandle(ref, () => ({
        beforeSave: validateBeforeSave,
        onPreview: validateBeforeSave
    }))

    React.useEffect(() => {
        //validateBeforeSave()
    }, [uiProps])


    function validateBeforeSave() {
        if (!isDataSourceValid(true)) return false
        return true
    }

    function isDataSourceValid(showError?: boolean) {
        if (!hasValue(uiProps?.source) || !hasValue(uiProps.source?.source) || !hasValue(uiProps.source?.path)) {

            if (showError) {
                designer?.addErrors?.([{
                    id: 'datasource',
                    type: 'property',
                    error: 'Data source is required',
                    containerId: 'currency-converter',
                    fieldId: 'source'
                }])
            }

            return false
        }
        designer?.removeErrors?.(['datasource'])
        return true
    }

    async function getCurrencies() {
        props?.uxpContext?.executeAction('currencies', 'GetCurrencies', {})
            .then(data => setCurrencies(JSON.parse(data)))

    }

    async function loadInitialDataAndContextData() {
        const { initialData } = await loadInitialData(props);
        const _data = await extractContextData(props, initialData, contextData);
        setContextData(_data);
    };

    useEffectWithPolling(props.uxpContext, 'currecny-convertion', 600000, async () => {

        if (designer?.mode == 'thumbnail' || !uiProps?.source) {
            return;
        }

        executeAndBind(props.uxpContext, uiProps.source, uiProps.datasources, {}, contextData)
            .then(d => setCurrencies(d))
    }, [props.designer]);

    function getCurrencyValue() {
        const fromRate = currencies.find((r: any) => r.symbol === fromCurrency)?.value;
        const toRate = currencies.find((r: any) => r.symbol === toCurrency)?.value;
        return (toRate / fromRate).toFixed(2);
    };

    function getName() {
        const currecny = currencies.find((r: any) => r.symbol === toCurrency)?.currency;
        return currecny;
    }

    const handleConversion = () => {
        const lc = currencies.find(r => r.symbol === fromCurrency)?.value;
        const rc = currencies.find(r => r.symbol === toCurrency)?.value;

        if (clickSide === 'right') {
            const converted = ((parseFloat(leftValue) / lc) * rc).toString();
            setRightValue(parseFloat(converted).toFixed(2));
        }

        if (clickSide === 'left') {
            const converted = ((parseFloat(rightValue) / rc) * lc).toString();
            setLeftValue((parseFloat(converted).toFixed(2)))
        }

    };

    function swapValues() {
        setToCurrency(fromCurrency);
        setFromCurrency(toCurrency);
        setLeftValue(rightValue);
        setRightValue(leftValue);
    }

    console.log("Swap outof : ", `${fromCurrency} ---> ${toCurrency}`);


    return (
        <WidgetWrapper className='uxp-custom-currency-converter-template'>
            <div className="bg" style={containerStyles}></div>
            <SelectableItem
                elementId='currency-converter'
                style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'container', 'source')}
            >
                <div className='container'>
                    <div className='title-bar-wrapper'>
                        <div className="uxp-widget-title-bar uxp-drag-handler">
                            <div className='title-section-wrapper'>
                                <SelectableItem
                                    designer={props.designer}
                                    props={selectUIProps(uiProps, XPRProps, 'title')}
                                >
                                    <div className="title-section">
                                        <span className="txt" style={{ color: titleColor, fontSize: `${titleFont}` }}>{title}</span>
                                    </div>
                                </SelectableItem>
                            </div>
                        </div>
                    </div>

                    <div className="data-area-container-wrapper">
                        <div className='main'>
                            <div className='from'>
                                <div className='input-section'>
                                    <Input
                                        className='input'
                                        value={leftValue}
                                        onChange={v => {
                                            setLeftValue(v);
                                            setClickSide('right');
                                        }} />
                                    <span className='label'>{fromCurrency}</span>
                                </div>
                                <div className='select-currency'>
                                    <Select
                                        key={fromCurrency}
                                        options={currencies}
                                        onChange={v => setFromCurrency(v)}
                                        selected={fromCurrency}
                                        labelField='symbol'
                                        valueField='symbol'
                                    />
                                </div>
                            </div>
                            <div className='to'>
                                <div className='input-section'>
                                    <Input
                                        className='input'
                                        value={rightValue}
                                        onChange={(v) => {
                                            setRightValue(v);
                                            setClickSide('left');
                                        }} />
                                    <span className='label'>{toCurrency}</span>
                                </div>
                                <div className='select-currency'>
                                    <Select
                                        key={toCurrency}
                                        options={currencies}
                                        onChange={v => setToCurrency(v)}
                                        selected={toCurrency}
                                        labelField='symbol'
                                        valueField='symbol'
                                    />
                                </div>
                            </div>
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'button')}
                            >

                                <div
                                    className={`convert-button`}
                                    onClick={() => {
                                        swapValues();
                                        setClickSide('right');
                                    }}
                                    style={{ background: btnColor }}
                                >
                                    <FontAwesomeIcon icon={'exchange-alt'} />
                                </div>
                            </SelectableItem>
                        </div>

                        <div className="footer">
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'text')}
                            >
                                <div className='text' style={{ color: textColor }}>{`1 ${fromCurrency} = ${getCurrencyValue()} ${getName()}`}</div>
                            </SelectableItem>
                        </div>
                    </div>
                </div>
            </SelectableItem>
        </WidgetWrapper>
    )
})


registerCardTemplate({
    id: 'currency-converter',
    name: "Currency Converter Card",
    description: 'A widget to convert currencies',
    template: XPR,
    icon: generateIconProp('tachometerAlt'),
    complexity: 'medium',
});

registerMobileCardTemplate({
    id: 'currency-converter',
    template: XPR,
    name: 'Currency Converter',
    description: 'A simple currency converter widget'
});